import type {
  DeleteApiTracksIdPathParams,
  PostApiTracksMutationRequest,
  PutApiTracksIdMutationRequest,
  PutApiTracksIdPathParams,
} from '@/shared/api'
import { STRINGS } from '@/shared/config'
import { showNotificationSuccessFx } from '@/shared/lib/providers'
import { createEvent, sample } from 'effector'

import {
  type DeleteApiTracksParams,
  type DeleteApiTracksParamsParams,
  trackCreate,
  trackDelete,
  trackMultipleDelete,
  trackUpdate,
} from '../api/track.api'

// Create

export const trackSubmitted = createEvent<PostApiTracksMutationRequest>()
sample({
  clock: trackSubmitted,
  fn: (data) => ({ data }),
  target: [trackCreate.start],
})

sample({
  clock: trackCreate.finished.success,
  fn: () => ({ message: STRINGS.success_creation }),
  target: showNotificationSuccessFx,
})

// Edit

export const trackEdited = createEvent<{
  id: PutApiTracksIdPathParams['Id']
  data: PutApiTracksIdMutationRequest
}>()
sample({
  clock: trackEdited,
  fn: ({ id, data }) => ({ id, data }),
  target: [trackUpdate.start],
})

sample({
  clock: trackUpdate.finished.success,
  fn: () => ({ message: STRINGS.success_update }),
  target: showNotificationSuccessFx,
})

// Delete

export const trackDeleted = createEvent<{
  id: DeleteApiTracksIdPathParams['Id']
}>()

sample({
  clock: trackDeleted,
  fn: ({ id }) => ({ id }),
  target: [trackDelete.start],
})

sample({
  clock: trackDelete.finished.success,
  fn: () => ({ message: STRINGS.success_deletion }),
  target: showNotificationSuccessFx,
})

// Delete Multiple

export const selectedTracksDeleted = createEvent<{
  trackIds: DeleteApiTracksParamsParams['TrackIds']
}>()

export const albumTracksDeleted = createEvent<{
  albumId: DeleteApiTracksParamsParams['AlbumId']
}>()

export const authorTracksDeleted = createEvent<{
  authorId: DeleteApiTracksParamsParams['AuthorId']
}>()

sample({
  clock: selectedTracksDeleted,
  fn: ({ trackIds: TrackIds }): DeleteApiTracksParams => ({
    params: { TrackIds },
  }),
  target: trackMultipleDelete.start,
})

sample({
  clock: albumTracksDeleted,
  fn: ({ albumId: AlbumId }): DeleteApiTracksParams => ({
    params: { AlbumId },
  }),
  target: trackMultipleDelete.start,
})

sample({
  clock: authorTracksDeleted,
  fn: ({ authorId: AuthorId }): DeleteApiTracksParams => ({
    params: { AuthorId },
  }),
  target: trackMultipleDelete.start,
})

sample({
  clock: trackMultipleDelete.finished.success,
  fn: () => ({ message: STRINGS.success_deletion_multiple }),
  target: showNotificationSuccessFx,
})
